/**
 * @generated SignedSource<<f14f0deceedcd54c49460cf7582a136c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExpenseCategory = "CONSULTING_AND_ADMINISTRATION" | "HARDWARE_AND_EQUIPMENT" | "INFRASTRUCTURE" | "INSURANCE" | "MEMBERSHIPS_AND_DONATIONS" | "OTHER" | "SERVICES_AND_LICENSES" | "TRAVEL" | "VEHICLES" | "%future added value";
export type AnalysisExpenseOverviewViewQuery$variables = {
  from: string;
  to: string;
};
export type AnalysisExpenseOverviewViewQuery$data = {
  readonly expenseMonthlyTotals: {
    readonly categories: ReadonlyArray<{
      readonly amounts: ReadonlyArray<{
        readonly isProvisional: boolean;
        readonly month: string;
        readonly netAmountInEuro: number;
      }>;
      readonly expenseCategory: ExpenseCategory | null | undefined;
      readonly netAmountInEuro: number;
      readonly suppliers: ReadonlyArray<{
        readonly amounts: ReadonlyArray<{
          readonly isProvisional: boolean;
          readonly month: string;
          readonly netAmountInEuro: number;
        }>;
        readonly netAmountInEuro: number;
        readonly supplierIdentifier: string;
        readonly supplierName: string;
      }>;
    }>;
    readonly months: ReadonlyArray<{
      readonly isComplete: boolean;
      readonly isProvisional: boolean;
      readonly month: string;
      readonly netAmountInEuro: number;
    }>;
  };
  readonly proposedServicePeriods: {
    readonly totalCount: number;
  };
};
export type AnalysisExpenseOverviewViewQuery = {
  response: AnalysisExpenseOverviewViewQuery$data;
  variables: AnalysisExpenseOverviewViewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "from"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "to"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "month",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "netAmountInEuro",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isProvisional",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "concreteType": "ExpenseMonthlyAmount",
  "kind": "LinkedField",
  "name": "amounts",
  "plural": true,
  "selections": [
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v5 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "from",
        "variableName": "from"
      },
      {
        "kind": "Variable",
        "name": "to",
        "variableName": "to"
      }
    ],
    "concreteType": "ExpenseMonthlyTotals",
    "kind": "LinkedField",
    "name": "expenseMonthlyTotals",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpenseMonthTotal",
        "kind": "LinkedField",
        "name": "months",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isComplete",
            "storageKey": null
          },
          (v2/*: any*/),
          (v3/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ExpenseCategoryMonthlyTotals",
        "kind": "LinkedField",
        "name": "categories",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "expenseCategory",
            "storageKey": null
          },
          (v2/*: any*/),
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "SupplierMonthlyTotals",
            "kind": "LinkedField",
            "name": "suppliers",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supplierIdentifier",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "supplierName",
                "storageKey": null
              },
              (v2/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  },
  {
    "alias": "proposedServicePeriods",
    "args": [
      {
        "kind": "Literal",
        "name": "filter",
        "value": {
          "servicePeriodStatus": "PROPOSED"
        }
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 1
      }
    ],
    "concreteType": "ExpenseInvoiceConnection",
    "kind": "LinkedField",
    "name": "expenseInvoices",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalCount",
        "storageKey": null
      }
    ],
    "storageKey": "expenseInvoices(filter:{\"servicePeriodStatus\":\"PROPOSED\"},first:1)"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AnalysisExpenseOverviewViewQuery",
    "selections": (v5/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AnalysisExpenseOverviewViewQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "6f7e41f73f5261a7e0a4242785a2b51a",
    "id": null,
    "metadata": {},
    "name": "AnalysisExpenseOverviewViewQuery",
    "operationKind": "query",
    "text": "query AnalysisExpenseOverviewViewQuery(\n  $from: String!\n  $to: String!\n) {\n  expenseMonthlyTotals(from: $from, to: $to) {\n    months {\n      month\n      isComplete\n      netAmountInEuro\n      isProvisional\n    }\n    categories {\n      expenseCategory\n      netAmountInEuro\n      amounts {\n        month\n        netAmountInEuro\n        isProvisional\n      }\n      suppliers {\n        supplierIdentifier\n        supplierName\n        netAmountInEuro\n        amounts {\n          month\n          netAmountInEuro\n          isProvisional\n        }\n      }\n    }\n  }\n  proposedServicePeriods: expenseInvoices(first: 1, filter: {servicePeriodStatus: PROPOSED}) {\n    totalCount\n  }\n}\n"
  }
};
})();

(node as any).hash = "ca4fb10769bbe7826c4cad3f3b122c54";

export default node;
